import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { Button, Title } from '../components'


const NotFoundPage = ({ intl }) => (
  <div className="page-not-found">
    <Title message={intl.formatMessage(messages.notFoundMsg)} />
    <p>{intl.formatMessage(messages.notFoundMsg)}</p>
    <Link to="/app">
      <Button positive>{intl.formatMessage(messages.homeLink)}</Button>
    </Link>
  </div>
)

NotFoundPage.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(NotFoundPage)

const messages = defineMessages({
  notFoundMsg: {
    id: 'notFound.page.notFoundMsg',
    defaultMessage: 'Stránka nebola nájdená.',
  },
  homeLink: {
    id: 'notFound.page.homeLink',
    defaultMessage: 'Domov',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/NotFoundPage.js